import React from 'react'
import ReactDOM from 'react-dom/client'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'
import { AuthGuard } from './components/AuthGuard'
import './i18n/config'
import './index.css'
import { AddBookingPage } from './pages/AddBookingPage'
import { AddChildPage } from './pages/AddChildPage'
import { AddMedicalHistory } from './pages/AddMedicalHistory'
import { CookiePolicyPage } from './pages/CookiePolicyPage'
import { EditBookingPage } from './pages/EditBookingPage'
import { EditChildPage } from './pages/EditChildPage'
import { EditProfilePage } from './pages/EditProfilePage'
import { HomePage } from './pages/HomePage'
import { LoginPage } from './pages/LoginPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage'
import { ProfileCompletionPage } from './pages/ProfileCompletionPage'
import { RegisterPage } from './pages/RegisterPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { ReturnAndCancelPolicy } from './pages/ReturnAndCancelPolicy'
import { SetNewPasswordPage } from './pages/SetNewPasswordPage'
import { TermsOfServicePage } from './pages/TermsOfServicePage'
import { VerificationPendingPage } from './pages/VerificationPendingPage'
import { VerifyEmailPage } from './pages/VerifyEmailPage'
import { initSentry } from './utils/sentry'

// Initialize Sentry
initSentry()

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: 'login',
        element: <LoginPage />
      },
      {
        path: 'register',
        element: <RegisterPage />
      },
      {
        path: 'verification-pending',
        element: <VerificationPendingPage />
      },
      {
        path: 'verify-email/:token',
        element: <VerifyEmailPage />
      },
      {
        path: 'reset-password',
        element: <ResetPasswordPage />
      },
      {
        path: 'reset-password/:token',
        element: <SetNewPasswordPage />
      },
      {
        path: 'profile-completion',
        element: (
          <AuthGuard requireEmailVerificationOnly>
            <ProfileCompletionPage />
          </AuthGuard>
        )
      },
      {
        index: true,
        element: (
          <AuthGuard>
            <HomePage />
          </AuthGuard>
        )
      },
      {
        path: 'profile/edit',
        element: (
          <AuthGuard>
            <EditProfilePage />
          </AuthGuard>
        )
      },
      {
        path: 'children/add',
        element: (
          <AuthGuard>
            <AddChildPage />
          </AuthGuard>
        )
      },
      {
        path: 'children/:id',
        element: (
          <AuthGuard>
            <EditChildPage />
          </AuthGuard>
        )
      },
      {
        path: 'medical-history/add',
        element: (
          <AuthGuard>
            <AddMedicalHistory />
          </AuthGuard>
        )
      },
      {
        path: 'bookings/add',
        element: (
          <AuthGuard>
            <AddBookingPage />
          </AuthGuard>
        )
      },
      {
        path: 'bookings/:id',
        element: (
          <AuthGuard>
            <EditBookingPage />
          </AuthGuard>
        )
      },
      {
        path: 'terms-of-service',
        element: <TermsOfServicePage />
      },
      {
        path: 'privacy-policy',
        element: <PrivacyPolicyPage />
      },
      {
        path: 'return-and-cancel-policy',
        element: <ReturnAndCancelPolicy />
      },
      {
        path: 'cookie-policy',
        element: <CookiePolicyPage />
      }
    ]
  }
])

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
) 